module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy_EN.1bc7c359.pdf";